var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"notranslate",staticStyle:{"word-break":"break-word"},attrs:{"translate":"no"}},[_vm._v(_vm._s(_vm.userfullname))])
}
var staticRenderFns = []

export { render, staticRenderFns }